import { Component, Input, OnInit } from "@angular/core";
import { CompareVersionsPeticionesService } from "src/app/core/services/compare-versions-peticiones.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import {
  dynamicsFields,
  camposdisponibles,
} from "src/app/coc/models/dynamicsFields";
import { AppConstants } from "src/app/constants/app.constants";
import { FieldBase, ShowField } from "../form-fields/model";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-compare-release-peticion",
  templateUrl: "./compare-release-peticion.component.html",
  styleUrls: ["./compare-release-peticion.component.scss"],
})
export class CompareReleasePeticionComponent implements OnInit {
  @Input() id: string;
  @Input() type: string;
  @Input() fields: any;
  @Input() isHistoric: boolean;
  @Input() peticion: any;

  compareOpened = false;
  release1 = {
    value: "",
    loaded: false,
    data: null,
    fieldsDynamic: [],
    fieldsDynamicAux: [],
    dataPlaca: [],
    bastidoresCOC: [],
  };
  release2 = {
    value: "",
    loaded: false,
    data: null,
    fieldsDynamic: [],
    fieldsDynamicAux: [],
    dataPlaca: [],
    bastidoresCOC: [],
  };
  listReleases = [];
  public fieldsSolicitudR1: FieldBase<any>[];
  public fieldsVehiculoR1: FieldBase<any>[];
  public fieldsSolicitudR2: FieldBase<any>[];
  public fieldsVehiculoR2: FieldBase<any>[];

  constructor(
    private compareVersionsPeticionesService: CompareVersionsPeticionesService,
    private toastrAlertService: ToastrAlertService,
    private listValueService: ListValueService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.getlistRelease();
  }

  private initValues(): void {
    this.release1 = {
      value: this.release1.value,
      loaded: false,
      data: null,
      fieldsDynamic: [],
      fieldsDynamicAux: [],
      dataPlaca: [],
      bastidoresCOC: [],
    };
    this.release2 = {
      value: this.release2.value,
      loaded: false,
      data: null,
      fieldsDynamic: [],
      fieldsDynamicAux: [],
      dataPlaca: [],
      bastidoresCOC: [],
    };
  }

  loadReleases(): void {
    this.initValues();
    if (
      parseInt(this.release1.value).toString() !== "NaN" &&
      parseInt(this.release2.value).toString() !== "NaN"
    ) {
      this.getRelease1();
      this.getRelease2();
    } else {
      this.toastrAlertService.toastrFail(
        "Selecciona correctamente ambas versiones"
      );
    }
  }

  getlistRelease(): void {
    this.listValueService.listValuesReleases(this.id).subscribe(
      (data) => {
        this.listReleases = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getRelease1(): void {
    this.compareVersionsPeticionesService
      .getRelease(
        this.id,
        parseInt(this.release1.value),
        this.type === "REFORMA",
        this.type === "CERTIFICADO"
      )
      .subscribe(
        (data) => {
          if (data.length > 0) {
            this.release1.data = data[0];
            this.fieldsSolicitudR1 = this.initFieldsSolicitud(this.release1);
            this.fieldsVehiculoR1 = this.initFieldsVehiculo(this.release1);
            if (this.type == "Placa" || this.type == "COC") {
              this.release1.fieldsDynamicAux = data;
              this.release1.fieldsDynamic =
                this.castingDynamicFieldsAtCompareReleases(
                  AppConstants.castDynamicsFields,
                  data
                );
              this.getBastidoresMasivo(this.release1);
            } else {
              this.release1.fieldsDynamic =
                this.castDynamicFieldsCertificates(data);
            }

            if (this.type == "Placa") {
              this.release1.data["tipoPlaca"] = this.getTipoPlaca(
                this.release1.fieldsDynamic
              );
              this.release1.dataPlaca = this.setValuesDataPlaca(this.release1);
            }

            this.release1.loaded = true;
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  getRelease2(): void {
    this.compareVersionsPeticionesService
      .getRelease(
        this.id,
        parseInt(this.release2.value),
        this.type === "REFORMA",
        this.type === "CERTIFICADO"
      )
      .subscribe(
        (data) => {
          if (data.length > 0) {
            this.release2.data = data[0];
            this.fieldsSolicitudR2 = this.initFieldsSolicitud(this.release2);
            this.fieldsVehiculoR2 = this.initFieldsVehiculo(this.release2);
            if (this.type == "Placa" || this.type == "COC") {
              this.release2.fieldsDynamicAux = data;
              this.release2.fieldsDynamic =
                this.castingDynamicFieldsAtCompareReleases(
                  AppConstants.castDynamicsFields,
                  data
                );
              this.getBastidoresMasivo(this.release2);
            } else {
              this.release2.fieldsDynamic =
                this.castDynamicFieldsCertificates(data);
            }

            if (this.type == "Placa") {
              this.release2.data["tipoPlaca"] = this.getTipoPlaca(
                this.release2.fieldsDynamic
              );
              this.release2.dataPlaca = this.setValuesDataPlaca(this.release2);
            }
            this.release2.loaded = true;
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  getTipoPlaca(release: any[]) {
    let tipoPlaca = "";
    release.forEach((element) => {
      if (element.campo == "TipoPlaca") {
        tipoPlaca = element.valor;
      }
    });
    return tipoPlaca;
  }

  setValuesDataPlaca(release) {
    let array = [];
    this.fields.forEach((element) => {
      let field = release.fieldsDynamicAux.find((e) => element.ciId == e.campo);
      if (field) {
        element.value = field.valor;
      }
      array.push(element);
    });
    return array;
  }

  castingDynamicFieldsAtCompareReleases(
    castDynamicsFields: any,
    detallepeticiones: any[]
  ): dynamicsFields[] {
    let dynamicsFieldsCasted: dynamicsFields[] = [];
    castDynamicsFields.forEach((element) => {
      let index = detallepeticiones.findIndex((e) => e.campo == element.id);
      if (index > -1) {
        let camposdisponibles: camposdisponibles = {
          ccObligatorio: null,
          cdId: null,
          cdListadb: element.list ? element.list : null,
          cdLongitud: null,
          cdTexto: null,
          cdTipo: element.type,
        };
        let object: dynamicsFields = {
          dpCampo: element.text,
          dpCampoid: detallepeticiones[index].campo,
          dpDocumentacion: "",
          dpFichero: detallepeticiones[index].nombreFichero,
          dpId: detallepeticiones[index].id,
          dpRelease: null,
          dpValor: detallepeticiones[index].valor,
          camposdisponibles: camposdisponibles,
        };
        dynamicsFieldsCasted.push(object);
      }
    });
    return dynamicsFieldsCasted;
  }

  private castDynamicFieldsCertificates(data: any[]): dynamicsFields[] {
    let dynamicsFieldsCasted: dynamicsFields[] = [];
    data.forEach((field) => {
      let camposdisponibles: camposdisponibles = {
        ccObligatorio: null,
        cdId: null,
        cdListadb: null,
        cdLongitud: null,
        cdTexto: null,
        cdTipo: field.cdTipo,
        ccPosicion: field.posicion,
      };
      let object: dynamicsFields = {
        camposdisponibles: camposdisponibles,
        dpCampo: field.campo,
        dpCampoid: field.campoId,
        dpDocumentacion: null,
        dpFichero: field.nombreFichero,
        dpId: null,
        dpRelease: null,
        dpValor: field.valor,
        dpReforma: field.reforma
          ? field.reforma + "-" + field.reformaDesc
          : null,
      };
      dynamicsFieldsCasted.push(object);
    });
    return dynamicsFieldsCasted;
  }

  private initFieldsSolicitud(release): FieldBase<any>[] {
    let fieldsSolicitud: FieldBase<any>[] = [
      new ShowField({
        label: "ID",
        value: release.data?.id,
      }),
    ];
    if (release.data.reforma) {
      fieldsSolicitud = [
        ...fieldsSolicitud,
        new ShowField({
          label: "Tipo certificado",
          value: this.peticion.peTcertificado,
        }),
      ];
    } else {
      fieldsSolicitud = [
        ...fieldsSolicitud,
        new ShowField({
          label: "Tipo certificado",
          value: release.data?.tipoCertificado,
        }),
      ];
    }
    fieldsSolicitud = [
      ...fieldsSolicitud,
      new ShowField({
        label: "Fecha solicitud",
        value: release.data.fechaSolicitud,
      }),
      new ShowField({
        label: "Hora solicitud",
        value: release.data.horaSolicitud,
      }),
    ];
    if (this.type == "Placa") {
      fieldsSolicitud = [
        ...fieldsSolicitud,
        new ShowField({
          label: "Imagen anterior",
          value: release.data.ImagenAnterior,
        }),
        new ShowField({
          label: "Imagen actual",
          value: release.data.imagenActual,
        }),
      ];
    }
    fieldsSolicitud = [
      ...fieldsSolicitud,
      new ShowField({
        label: "Concesionario",
        value: release.data?.concesionario,
      }),
      new ShowField({
        label: "Usuario",
        value: release.data.usuario,
      }),
      new ShowField({
        label: "Teléfono",
        value: release.data.usTelefono,
      }),
      new ShowField({
        label: "Estado",
        value: release.data?.estado,
      }),
      new ShowField({
        label: "Fecha tramitación",
        value: release.data?.fechaTramitacion,
      }),
      new ShowField({
        label: "Fecha facturación",
        value: release.data?.fechaFacturacion,
      }),
    ];

    return fieldsSolicitud;
  }
  private initFieldsVehiculo(release): FieldBase<any>[] {
    let fieldsVehiculo = [
      new ShowField({
        label: "Número de bastidor",
        value: release.data?.bastidor,
      }),
    ];
    if (this.type != "COC") {
      fieldsVehiculo = [
        ...fieldsVehiculo,
        new ShowField({
          label: "Código VIN",
          value: release.data?.tipo,
        }),
      ];
      if (this.type != "Placa") {
        fieldsVehiculo = [
          ...fieldsVehiculo,
          new ShowField({
            label: "Variante",
            value: release.data?.variante,
          }),
          new ShowField({
            label: "Versión",
            value: release.data?.version,
          }),
        ];
      }
      fieldsVehiculo = [
        ...fieldsVehiculo,
        new ShowField({
          label: "Contraseña",
          value: release.data?.contrasena,
        }),
        new ShowField({
          label: "Marca",
          value: release.data?.marca,
        }),
        new ShowField({
          label: "Denominación comercial",
          value: release.data?.peDenominacionComercial,
        }),
        new ShowField({
          label: "Código motor",
          value: release.data?.tipoMotor,
        }),
      ];
      if (this.type != "Placa") {
        fieldsVehiculo = [
          ...fieldsVehiculo,
          new ShowField({
            label: "Matricula",
            value: release.data?.matricula,
          }),
        ];
      }
    }
    return fieldsVehiculo;
  }

  public downloadFile(field: dynamicsFields, release: any): void {
    this.sweetAlertService.sweetAlertLoading();
    let dpCampo = field.dpCampo;
    if (this.type == "Placa" || this.type == "COC") {
      dpCampo = field.dpCampoid;
    }
    this.commonService
      .getFilesOfDetallePeticiones(
        dpCampo,
        this.id,
        release.value,
        this.isHistoric ? "true" : "false"
      )
      .subscribe(
        (data) => {
          this.commonService.downloadFile(data, field.dpFichero);
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  public getBastidoresMasivo(release: any): void {
    if (
      release.data &&
      (release.data.tipoCertificado == "CM" ||
        release.data.peTcertificado == "CML")
    ) {
      if (this.isHistoric) {
        this.listValueService
          .listHBastidoresCOC(this.id, release.value)
          .subscribe(
            (data) => {
              release.bastidoresCOC = data;
            },
            (err) => {
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
      } else {
        this.listValueService
          .listBastidoresCOC(this.id, release.value)
          .subscribe(
            (data) => {
              release.bastidoresCOC = data;
            },
            (err) => {
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
      }
    }
  }
}
